class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink)
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => { this.classList.add('animate', 'active') });

    this.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = this.classList.contains('is-empty') ? this.querySelector('.drawer__inner-empty') : document.getElementById('CartDrawer');
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
      trapFocus(containerToTrapFocusOn, focusElement);
    }, { once: true });
    if(document.querySelector("#Details-menu-drawer-container").hasAttribute("open")){
      document.querySelector("#Details-menu-drawer-container").removeAttribute("open");
      document.querySelector("#Details-menu-drawer-container").classList.remove("menu-opening");
      document.querySelector(".header__icon--menu").setAttribute("aria-expanded",false);
      document.body.classList.remove("overflow-hidden-tablet");
      document.querySelector(".section-header").classList.remove("menu-open");
    }
    if(document.querySelector(".header__search details").hasAttribute("open")){
      document.querySelector(".header__search details").removeAttribute("open");
      document.querySelector(".section-header").classList.remove("menu-open");
    }
    document.body.classList.add('overflow-hidden');

         //flikity slider
        //  const slider = document.getElementById('flickity_upsell'); // match your ID
        //   if (!slider) return;
        //   const isRTL = ['he', 'ar', 'arc', 'az', 'dv', 'ku', 'fa', 'ur'].includes(
        //     document.documentElement.lang
        //   );
        //   console.log("isRTL",isRTL)
        //   const flkty = new Flickity(slider, {
        //     imagesLoaded: true,
        //     rightToLeft: isRTL,
        //     cellAlign: 'right',
        //     pageDots: false,
        //     wrapAround: false,
        //     contain: true,
        //     prevNextButtons: false
        //   });
        //flikity slider ends here
      
  initAccordionWithStorage(); // freeproducts
  initUpsellToggle();         // upsellproducts

  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState,discount,discountcode) {
    
    // const cartDrawerHTML = this.querySelector('.drawer__cart-items-wrapper');
    // if (cartDrawerHTML) {
    //   this.querySelector('.drawer__inner').classList.remove('is-empty');
    // } else {
    //   this.querySelector('.drawer__inner').classList.add('is-empty');
    // }

    this.querySelector('.drawer__inner').classList.contains('is-empty') && this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      // console.log(parsedState.sections[section.id],"parsedState.sections[section.id]")
      if(discount){
        const parser = new DOMParser();
        let CARThtml = parser.parseFromString(parsedState.sections[section.id], "text/html");
        var discount_applied = false;
        if(CARThtml.querySelector("ul.discounts.list-unstyled")){
          CARThtml.querySelectorAll("ul.discounts.list-unstyled").forEach((ele) => {
            if(ele.innerHTML){
              discount_applied = true;
              return false;
            }
          })
          if(discount_applied){
            console.log("discount applied",discount_applied)
            setTimeout(function(){
              document.querySelector("cart-coupon-form .error").classList.add("d-none");
              }, 500);
          }else{
            setTimeout(function(){
              let pre_Val = discountcode;
              document.querySelector(".promo-code-wrap").classList.add("open");
              document.querySelector("cart-coupon-form .error").classList.remove("d-none");
              document.querySelector("cart-coupon-form input[type='text']").value = pre_Val;
            }, 500);
            
          }
        }
      }
      const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      sectionElement.innerHTML =
        this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    }));

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });

    // new js by riya
   this.querySelector('.cart-items') || this.classList.add('is-empty');
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

// Always-visible scrollbar for the drawer's product list. Mobile browsers only show their
// native scrollbar while scrolling, so customers can't tell more products are below.
// The drawer markup is re-rendered on every cart change, so each new instance sets itself up.
class CartItemsScroll extends HTMLElement {
  connectedCallback() {
    this.scroller = this.querySelector('.cart-items-wrapper');
    this.track = this.querySelector('.cart-items-scroll__track');
    this.thumb = this.querySelector('.cart-items-scroll__thumb');
    if (!this.scroller || !this.track || !this.thumb) return;

    this.requestUpdate = () => {
      if (!this.frame) this.frame = requestAnimationFrame(() => this.update());
    };
    this.scroller.addEventListener('scroll', this.requestUpdate, { passive: true });
    this.resizeObserver = new ResizeObserver(this.requestUpdate);
    this.resizeObserver.observe(this.scroller);
    if (this.scroller.firstElementChild) this.resizeObserver.observe(this.scroller.firstElementChild);
  }

  disconnectedCallback() {
    if (this.scroller) this.scroller.removeEventListener('scroll', this.requestUpdate);
    if (this.resizeObserver) this.resizeObserver.disconnect();
    cancelAnimationFrame(this.frame);
    this.frame = null;
  }

  update() {
    this.frame = null;
    const { scrollTop, scrollHeight, clientHeight } = this.scroller;
    const maxScroll = scrollHeight - clientHeight;
    this.classList.toggle('is-scrollable', maxScroll > 1);
    if (maxScroll <= 1) return;

    const trackHeight = this.track.clientHeight;
    const thumbHeight = Math.max((trackHeight * clientHeight) / scrollHeight, 24);
    // Clamp so iOS overscroll bounce doesn't push the thumb outside the track
    const offset = ((trackHeight - thumbHeight) * Math.min(Math.max(scrollTop, 0), maxScroll)) / maxScroll;
    this.thumb.style.height = `${thumbHeight}px`;
    this.thumb.style.transform = `translateY(${offset}px)`;
  }
}

customElements.define('cart-items-scroll', CartItemsScroll);


//Coupon Code
class PromoCodeSection extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.target.classList.contains('cart-coupon-main') ? this.querySelector('.promo-code-wrap').classList.toggle('open') : null;
  
    });
  }
}

customElements.define('promo-code-wrap', PromoCodeSection);


class CartCouponCodeButton extends HTMLElement {
  constructor() {
    super();
    let current_form = this;
    this.querySelector('#coupon-form').addEventListener('submit', (event) => {

      event.preventDefault();
      this.submitForm(current_form.querySelector('.promo-input.couponCode').value)
    });
  }
 

   applyCouponCode(discountCode) {
    return new Promise((resolve, reject) => {
      let discountApplyUrl = "https://" + window.location.host + "/discount/" + discountCode;
  
      // Create a hidden iframe to apply discount using the checkout session
      let i = document.createElement('iframe');
      i.style.display = 'none';
      
      // Success: Remove iframe after it loads and log success message
      i.onload = function() {
        console.log("Discount code applied successfully."); // Log success
        i.parentNode.removeChild(i); // Clean up the iframe
        resolve(); // Resolve the promise for success
      };
  
      // Error: Handle iframe loading error
      i.onerror = function() {
        console.error("Failed to apply discount code."); // Log error message
        i.parentNode.removeChild(i); // Clean up the iframe
        reject(new Error("Failed to apply discount code.")); // Reject with error
      };
  
      i.src = discountApplyUrl;
      document.body.appendChild(i); // Append iframe to the body
    });
  }
  
  submitForm(discountCode){
    let current_this = this
    current_this.applyCouponCode(discountCode)
    .then(() => {
        console.log("Discount applied successfully!");
        fetch(`${routes.cart_url}?sections=cart-drawer,cart-icon-bubble`)
        .then((response) => response.json())
        .then((response) => {
            let responseFormated = {
                sections: response
            }
            let cart_drawer = document.querySelector('cart-drawer');
            cart_drawer.renderContents(responseFormated,"discount",discountCode)
            
        })
      })
    .catch(error => {
        console.error("Error applying discount:", error.message);
    });
  }
}

customElements.define('cart-coupon-form', CartCouponCodeButton);


// This js is cart drawer Free product, upsell product and free gift card
// Shared accordion logic with localStorage
window.addEventListener("beforeunload", () => {
  localStorage.removeItem("accordionOpenId");
});

document.addEventListener("DOMContentLoaded", () => {

  // Remove hidden class from slider on load
  const slider = document.querySelector(".cart-upsell .slider-component-desktop");
  if (slider) {
    slider.classList.remove("hidden");
  }

  const savedId = localStorage.getItem("accordionOpenId");

});

function initAccordionWithStorage() {
  const buttons = document.querySelectorAll("[data-accordion-id]");
  const storageKey = "activeAccordion";
  const savedId = localStorage.getItem(storageKey);

  buttons.forEach((button) => {
    const list = button.nextElementSibling;
    const id = button.getAttribute("data-accordion-id");

    if (!id || !list) return;

    if (savedId === id) {
      list.classList.remove("hidden");
    } else {
      list.classList.add("hidden");
    }

    button.replaceWith(button.cloneNode(true));
  });

  document.querySelectorAll("[data-accordion-id]").forEach((button) => {
    const list = button.nextElementSibling;
    const id = button.getAttribute("data-accordion-id");

    if (!list) return;

    button.addEventListener("click", function () {
      const isOpen = !list.classList.contains("hidden");

      // CLOSE EVERYTHING (accordion + upsell)
      document.querySelectorAll("[data-accordion-id], [data-upsell-id]").forEach((btn) => {
        const el = btn.nextElementSibling;
        if (el) el.classList.add("hidden");
      });

      if (!isOpen) {
        list.classList.remove("hidden");
        localStorage.setItem(storageKey, id);
      } else {
        localStorage.removeItem(storageKey);
      }
    });
  });
}

function initUpsellToggle(openFirstByDefault = true) {
  const buttons = document.querySelectorAll("[data-upsell-id]");
  const storageKey = "activeAccordion";
  const savedId = localStorage.getItem(storageKey);

  let hasActive = false;

  buttons.forEach((button, index) => {
    const list = button.nextElementSibling;
    const id = button.getAttribute("data-upsell-id");

    if (!id || !list) return;

    // If something already saved
    if (savedId === id) {
      list.classList.remove("hidden");
      hasActive = true;
    } else {
      list.classList.add("hidden");
    }

    button.replaceWith(button.cloneNode(true));
  });

  // DEFAULT: open first upsell if nothing saved (skipped after a cart update so a closed tab stays closed)
  if (openFirstByDefault && !savedId && buttons.length > 0) {
    const firstBtn = document.querySelector("[data-upsell-id]");
    const firstList = firstBtn?.nextElementSibling;
    const firstId = firstBtn?.getAttribute("data-upsell-id");

    if (firstList && firstId) {
      firstList.classList.remove("hidden");
      localStorage.setItem(storageKey, firstId);
    }
  }

  // Click logic (same as before)
  document.querySelectorAll("[data-upsell-id]").forEach((button) => {
    const list = button.nextElementSibling;
    const id = button.getAttribute("data-upsell-id");

    if (!list) return;

    button.addEventListener("click", function () {
      const isOpen = !list.classList.contains("hidden");

      document.querySelectorAll("[data-accordion-id], [data-upsell-id]").forEach((btn) => {
        const el = btn.nextElementSibling;
        if (el) el.classList.add("hidden");
      });

      if (!isOpen) {
        list.classList.remove("hidden");
        localStorage.setItem(storageKey, id);
      } else {
        localStorage.removeItem(storageKey);
      }
    });
  });
}
document.addEventListener("DOMContentLoaded", () => {
  initAccordionWithStorage(); // freeproducts
  initUpsellToggle();         // upsellproducts
});

// -------- CartFreeProducts ----------
let _prevSampleTierMin = undefined; // undefined = never initialized, null = no tier qualified, number = tier min cents

class CartFreeProducts extends HTMLElement {
  constructor() {
    super();
    console.log('[samples] CartFreeProducts constructor');
    initAccordionWithStorage("accordion-freeproducts");
    this.init();

    this.querySelectorAll(".show_more").forEach((e) => {
      e.addEventListener("click", (button) => {
        let btn = button.target;
        btn.closest(".product_info").querySelector(".product_description").classList.toggle("show");
        btn.closest(".show_more").classList.toggle("show");
        console.log(btn,"btn")
      })
    })
    
  }

  async init() {
    const rebuilt = await this.fetchAndRenderSampleProducts();
    if (rebuilt) {
      this.initCheckboxListeners();
      this.initSampleCartWarnings();
    }
  }

  async fetchAndRenderSampleProducts() {
    // Hide the list immediately (before the async yield) so initAccordionWithStorage
    // opening it doesn't cause a flash of empty content.
    const earlyList = document.getElementById('sample-products-list');
    if (earlyList) earlyList.style.opacity = '0';

    await new Promise(resolve => setTimeout(resolve, 0));
    const scriptEl = document.getElementById('sample-config-data');
    if (!scriptEl) {
      if (earlyList) earlyList.style.opacity = '';
      return;
    }

    let data;
    try {
      data = JSON.parse(scriptEl.textContent);
    } catch (e) {
      console.error('[samples] config parse error:', e);
      return;
    }

    const cartTotalCents = data.cartTotalCents;
    const maxSamples = data.maxSamples;
    const cartItems = data.cartItems || [];
    const list = document.getElementById('sample-products-list');
    if (!list) {
      if (earlyList) earlyList.style.opacity = '';
      return false;
    }

    const qualifiedProductIds = new Set();
    const allProducts = [];

    // Support both new format (tiers with pre-fetched data) and old format (config with handles)
    // Old config format has GID strings like "gid://shopify/Product/123" — extract numeric ID
    const extractNumericId = (id) => {
      if (typeof id === 'string' && id.includes('/')) return parseInt(id.split('/').pop(), 10);
      return id;
    };

    const tiers = data.tiers
      ? data.tiers.filter(tier => tier.products && tier.products.length)
      : (data.config || []).map(tier => ({
          minAmountCents: tier.min_amount * 100,
          maxSamples: tier.max_samples,
          products: tier.products.map(p => ({ id: extractNumericId(p.id), handle: p.handle }))
        }));

    // For products Liquid couldn't resolve by handle, try AJAX with proper URL encoding
    const unresolvedProducts = [];
    tiers.forEach(tier => {
      tier.products.forEach(p => {
        if (!p.id && p.handle) unresolvedProducts.push(p);
      });
    });

    if (unresolvedProducts.length > 0) {
      await Promise.allSettled(unresolvedProducts.map(async (p) => {
        try {
          // Diagnostic: show exact char codes to detect invisible Unicode characters
          console.log('[samples] handle charCodes:', p.handle, [...p.handle].map(c => c.codePointAt(0).toString(16)).join(' '));

          // First try by handle with proper URL encoding
          const url = '/products/' + encodeURIComponent(p.handle) + '.js';
          const res = await fetch(url);
          if (res.ok) {
            const prod = await res.json();
            p.id = prod.id;
            p.title = prod.title;
            const imgRaw = prod.featured_image || '';
            p.image = imgRaw ? imgRaw.replace(/(\.[^.?]+)(\?|$)/, '_150x$1$2') : '';
            p.variantId = prod.variants && prod.variants[0] ? prod.variants[0].id : null;
            return;
          }

          // Handle lookup failed — search by reconstructed title (dashes → spaces)
          const numericId = p.gid ? extractNumericId(p.gid) : null;
          const searchTitle = p.handle.replace(/-/g, ' ').trim();
          const searchUrl = `/search/suggest.json?q=${encodeURIComponent(searchTitle)}&resources[type]=product&resources[limit]=10`;
          const searchRes = await fetch(searchUrl);
          if (searchRes.ok) {
            const searchData = await searchRes.json();
            const results = (searchData.resources && searchData.resources.results && searchData.resources.results.products) || [];
            // Match by numeric ID if we have it, otherwise fall back to first result
            const match = numericId
              ? results.find(r => Number(r.id) === numericId)
              : results[0];
            if (match) {
              p.id = Number(match.id);
              p.title = match.title;
              p.image = (match.featured_image && match.featured_image.url) ? match.featured_image.url.replace(/(\.[^.?]+)(\?|$)/, '_150x$1$2') : '';
              // Fetch full product via search-returned handle to get variantId
              try {
                const prodRes = await fetch('/products/' + encodeURIComponent(match.handle) + '.js');
                if (prodRes.ok) {
                  const prod = await prodRes.json();
                  p.variantId = prod.variants && prod.variants[0] ? prod.variants[0].id : null;
                  if (!p.image && prod.featured_image) {
                    p.image = prod.featured_image.replace(/(\.[^.?]+)(\?|$)/, '_150x$1$2');
                  }
                }
              } catch (_) {}
              console.log('[samples] found via search:', p.title, 'correct handle:', match.handle);
              return;
            }
          }

          console.warn('[samples] product not found — GID:', p.gid, 'handle tried:', p.handle);
        } catch (e) {
          console.warn('[samples] AJAX error for handle:', p.handle, e);
        }
      }));
    }

    // Find the HIGHEST qualified tier — only its products are selectable
    let highestQualifiedTier = null;
    tiers.forEach(tier => {
      if (cartTotalCents >= tier.minAmountCents) {
        if (!highestQualifiedTier || tier.minAmountCents > highestQualifiedTier.minAmountCents) {
          highestQualifiedTier = tier;
        }
      }
    });

    // When no tier qualifies, show the lowest-threshold tier as a locked preview
    const lowestTier = tiers.length > 0
      ? tiers.reduce((min, t) => t.minAmountCents < min.minAmountCents ? t : min)
      : null;
    const displayTier = highestQualifiedTier || lowestTier;

    // Cumulative: qualified users see products from ALL tiers up to their highest qualified tier.
    // Preview (no tier qualifies): show only the lowest tier's products, all locked.
    tiers.forEach(tier => {
      const include = highestQualifiedTier
        ? tier.minAmountCents <= highestQualifiedTier.minAmountCents
        : (displayTier && tier.minAmountCents === displayTier.minAmountCents);
      if (!include) return;
      tier.products.forEach(p => {
        if (!p.id) return;
        const numId = extractNumericId(p.id);
        if (!numId) return;
        if (!allProducts.find(x => extractNumericId(x.id) === numId)) allProducts.push({ ...p, id: numId });
        if (highestQualifiedTier) qualifiedProductIds.add(numId);
      });
    });

    // Auto-correct sample cart items: remove unqualified tier items, trim total qty to maxSamples
    const sampleCartItems = cartItems.filter(i => i.isSample);
    const unqualifiedSamples = sampleCartItems.filter(i => !qualifiedProductIds.has(i.productId));
    const qualifiedSamples = sampleCartItems.filter(i => qualifiedProductIds.has(i.productId));

    const trimUpdates = [];
    unqualifiedSamples.forEach(item => trimUpdates.push({ id: String(item.variantId), quantity: 0 }));

    // Trim total qty of qualified samples down to maxSamples if needed
    let remaining = maxSamples;
    qualifiedSamples.forEach(item => {
      const allowedQty = Math.min(item.qty, remaining);
      remaining -= allowedQty;
      if (allowedQty !== item.qty) {
        trimUpdates.push({ id: String(item.variantId), quantity: allowedQty });
      }
    });

    if (trimUpdates.length > 0) {
      await Promise.allSettled(trimUpdates.map(update =>
        fetch("/cart/change.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(update),
        })
      ));
      const sectionRes = await fetch(`${routes.cart_url}?sections=cart-drawer,cart-icon-bubble`);
      const sectionData = await sectionRes.json();
      const cart_drawer = document.querySelector("cart-drawer");
      if (cart_drawer && typeof cart_drawer.renderContents === "function") {
        cart_drawer.renderContents({ sections: sectionData });
      }
      return false; // new render cycle takes over
    }

    // Total qty of all selected sample products (used to enforce max_samples cap)
    const totalSampleQty = cartItems
      .filter(i => i.isSample && qualifiedProductIds.has(i.productId))
      .reduce((sum, i) => sum + (i.qty || 1), 0);

    // Build state keys to decide how much work to do
    const tierKey = `${maxSamples}|${displayTier ? displayTier.minAmountCents : 'none'}|${allProducts.map(p => p.id).sort((a, b) => a - b).join(',')}`;
    const cartKey = cartItems.filter(i => i.isSample).map(i => `${i.productId}:${i.qty}`).sort().join(',');

    if (this._tierKey === tierKey && list.children.length > 0) {
      if (this._cartKey === cartKey) {
        // Nothing changed — just reveal and skip
        list.style.opacity = '';
        return false;
      }
      // Only cart sample state changed — update checkboxes in-place, no rebuild
      this._cartKey = cartKey;
      this._syncCheckboxStates(list, allProducts, qualifiedProductIds, cartItems, totalSampleQty, maxSamples, extractNumericId);
      list.style.opacity = '';
      return false;
    }

    // Tier or product list changed — full rebuild
    this._tierKey = tierKey;
    this._cartKey = cartKey;

    this._autoOpenIfTierChanged(highestQualifiedTier);

    list.innerHTML = '';
    allProducts.forEach((product, index) => {
      const numId = extractNumericId(product.id);
      const isQualified = maxSamples > 0 && qualifiedProductIds.has(numId);
      const isInCart = cartItems.some(item => item.isSample && item.productId === numId);
      const isDisabled = !isQualified || (!isInCart && totalSampleQty >= maxSamples);
      const rawTitle = product.title || '';
      const title = rawTitle.length > 16 ? rawTitle.substring(0, 16) + '...' : rawTitle;
      const imgRaw = product.image || '';
      const imgSrc = (imgRaw && !imgRaw.includes('no-image')) ? imgRaw : '';
      const gramValue = [product.volume, product.size].filter(Boolean).join(' ');

      const li = document.createElement('li');
      li.className = 'free-sample-product-wrap' + (isQualified ? '' : ' is-tier-locked');
      li.id = `gift-wrap-${index + 1}`;
      li.innerHTML = `
        <div class="single-sample-product">
          <input type="checkbox"
            data-proid="${numId}"
            data-variant-id="${product.variantId || ''}"
            name="gift-sample-product"
            ${isInCart ? 'checked' : ''}
            ${isDisabled ? 'disabled' : ''}>
          <span class="fake_input"></span>
        </div>
        <div class="gift-wrap-card">
          <div class="product_image">
            ${imgSrc
              ? `<img src="${imgSrc}" alt="${rawTitle}" loading="lazy">`
              : '<div class="product_image_placeholder"></div>'}
          </div>
          <div class="product_info">
            <h5 class="pro_title">${title}</h5>
            ${gramValue ? `<p class="gram_value">${gramValue}</p>` : ''}
          </div>
        </div>`;
      list.appendChild(li);
    });

    list.style.opacity = '';
    return true; // full rebuild — callers must re-attach listeners
  }

  _autoOpenIfTierChanged(highestQualifiedTier) {
    const currMin = highestQualifiedTier ? highestQualifiedTier.minAmountCents : null;
    const prevMin = _prevSampleTierMin;
    _prevSampleTierMin = currMin;

    // undefined = initial page load, do nothing
    if (prevMin === undefined) return;

    const tierWentUp = currMin !== null && (prevMin === null || currMin > prevMin);
    const tierDroppedToNone = currMin === null && prevMin !== null;

    if (tierWentUp) {
      localStorage.setItem('activeAccordion', 'freeproducts');
      document.querySelectorAll('[data-accordion-id], [data-upsell-id]').forEach(btn => {
        const panel = btn.nextElementSibling;
        if (!panel) return;
        btn.getAttribute('data-accordion-id') === 'freeproducts'
          ? panel.classList.remove('hidden')
          : panel.classList.add('hidden');
      });
    } else if (tierDroppedToNone) {
      localStorage.removeItem('activeAccordion');
      const panel = document.querySelector('[data-accordion-id="freeproducts"]')?.nextElementSibling;
      if (panel) panel.classList.add('hidden');
    }
  }

  _syncCheckboxStates(list, allProducts, qualifiedProductIds, cartItems, totalSampleQty, maxSamples, extractNumericId) {
    allProducts.forEach(product => {
      const numId = extractNumericId(product.id);
      const isInCart = cartItems.some(item => item.isSample && item.productId === numId);
      const isQualified = maxSamples > 0 && qualifiedProductIds.has(numId);
      const isDisabled = !isQualified || (!isInCart && totalSampleQty >= maxSamples);
      const checkbox = list.querySelector(`input[data-proid="${numId}"]`);
      if (!checkbox) return;
      checkbox.checked = isInCart;
      isDisabled ? checkbox.setAttribute('disabled', '') : checkbox.removeAttribute('disabled');
    });
  }

  showLimitError(maxSamples) {
    let banner = this.querySelector('.sample-limit-banner');
    if (!banner) {
      banner = document.createElement('div');
      banner.className = 'sample-limit-banner sample-max-warning';
      banner.innerHTML = `<span class="sample-max-warning__icon">!</span><span></span>`;
      const list = this.querySelector('#sample-products-list');
      if (list) list.before(banner);
      else this.appendChild(banner);
    }
    banner.querySelector('span:last-child').textContent = maxSamples === 0
      ? 'לא ניתן לבחור דוגמיות עדיין'
      : `אתה יכול רק להוסיף ${maxSamples} דוגמיות לעגלה שלך.`;
    banner.style.display = 'flex';
  }

  clearLimitError() {
    const banner = this.querySelector('.sample-limit-banner');
    if (banner) banner.style.display = 'none';
  }

  initCheckboxListeners() {
    const maxSamples = parseInt(this.getAttribute("data-max-samples") || "0", 10);

    this.querySelectorAll(".single-sample-product").forEach((wrapper) => {
      wrapper.addEventListener("click", (event) => {
        const input = wrapper.querySelector("input[type='checkbox']");
        if (input && input.disabled) {
          event.preventDefault();
          this.showLimitError(maxSamples);
        }
      });
    });

    this.querySelectorAll("input[type='checkbox']").forEach((checkbox) => {
      checkbox.addEventListener("change", async (event) => {
        const newVariantId = Number(event.target.getAttribute("data-variant-id"));

        if (event.target.checked) {
          const checkedCount = this.querySelectorAll("input[type='checkbox']:checked").length;
          if (checkedCount > maxSamples) {
            event.target.checked = false;
            this.showLimitError(maxSamples);
            return;
          }
          this.clearLimitError();
          await this.addToCart(newVariantId);
        } else {
          const newProductId = Number(event.target.getAttribute("data-proid"));
          this.clearLimitError();
          await this.removeFromCart(newVariantId, newProductId);
        }
      });
    });
  }

  async addToCart(variantId) {
    try {
      const response = await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: variantId, quantity: 1, properties: { sample: "free" } }),
      });

      if (!response.ok) throw new Error("Add to cart failed");

      const sectionRes = await fetch(`${routes.cart_url}?sections=cart-drawer,cart-icon-bubble`);
      const sectionData = await sectionRes.json();
      const cart_drawer = document.querySelector("cart-drawer");
      if (cart_drawer && typeof cart_drawer.renderContents === "function") {
        cart_drawer.renderContents({ sections: sectionData });
      }
    } catch (err) {
      console.error("Error adding to cart:", err);
    }
  }

  initSampleCartWarnings() {
    const maxSamples = parseInt(this.getAttribute("data-max-samples") || "0", 10);
    if (maxSamples === 0) return;

    const getRows = () => Array.from(document.querySelectorAll('tr[data-sample-item="true"]'));

    const getTotalSampleQty = () =>
      getRows().reduce((sum, row) => {
        const input = row.querySelector('.quantity__input');
        return sum + parseInt(input ? input.value : '1', 10);
      }, 0);

    const showRowWarning = (row) => {
      if (row.querySelector('.sample-max-warning')) return;
      const warning = document.createElement('div');
      warning.className = 'sample-max-warning';
      warning.innerHTML = `<span class="sample-max-warning__icon">!</span><span>אתה יכול רק להוסיף ${maxSamples} דוגמיות לעגלה שלך.</span>`;
      const quantityCell = row.querySelector('.cart-item__quantity');
      if (quantityCell) quantityCell.prepend(warning);
    };

    const hideRowWarning = (row) => {
      const w = row.querySelector('.sample-max-warning');
      if (w) w.remove();
    };

    getRows().forEach(row => {
      const plusBtn = row.querySelector('[name="plus"]');
      const minusBtn = row.querySelector('[name="minus"]');
      const input = row.querySelector('.quantity__input');
      if (!plusBtn || !input) return;

      plusBtn.addEventListener('click', (e) => {
        const total = getTotalSampleQty();
        const currentQty = parseInt(input.value || '1', 10);
        if (total >= maxSamples || currentQty >= maxSamples) {
          e.preventDefault();
          e.stopImmediatePropagation();
          showRowWarning(row);
        }
      }, true);

      if (minusBtn) {
        minusBtn.addEventListener('click', () => hideRowWarning(row));
      }
    });
  }

  async removeFromCart(variantId, productId) {
    try {
      let removeId = variantId ? String(variantId) : null;

      if (!removeId && productId) {
        const cartRes = await fetch('/cart.js');
        const cart = await cartRes.json();
        const item = cart.items.find(i => i.product_id === productId);
        if (item) removeId = String(item.variant_id);
      }

      if (!removeId) return;

      const response = await fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: removeId, quantity: 0 }),
      });

      if (!response.ok) throw new Error("Remove from cart failed");

      const sectionRes = await fetch(`${routes.cart_url}?sections=cart-drawer,cart-icon-bubble`);
      const sectionData = await sectionRes.json();
      const cart_drawer = document.querySelector("cart-drawer");
      if (cart_drawer && typeof cart_drawer.renderContents === "function") {
        cart_drawer.renderContents({ sections: sectionData });
      }
    } catch (err) {
      console.error("Error removing from cart:", err);
    }
  }
}
customElements.define("cart-free-products", CartFreeProducts);
